import { render, staticRenderFns } from "./ValidarView.vue?vue&type=template&id=ed008c5a&"
import script from "./ValidarView.vue?vue&type=script&lang=ts&"
export * from "./ValidarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports